<div class="row d-md-flex justify-content-end">
    <div class="col-md-3 col-6 mb-3">
        <div class="input-group">
            <input type="text" readonly [value]="selectedDate" placeholder="Date ranges" class="form-control">
            <button (click)="calendarDialog.show()" class="btn btn-sm btn-outline-primary" type="button" [attr.disabled]="loading.status ? 'disabled' : null">
                <i class="material-icons">
                    date_range
                </i>
            </button>
        </div>
    </div>
    <div class="col-md-3 col-6 mb-3">
        <select class="form-select ms-1" [attr.disabled]="loading.status ? 'disabled' : null" [(ngModel)]="quizFilter" (ngModelChange)="query.quiz=quizFilter;getData()">
            <option value="WPPSI">WPPSI</option>
            <option value="WPPSI|Visual Spatial Index">WPPSI Visual Spatial</option>
            <option value="WPPSI|Processing Speed Index">WPPSI Processing Speed</option>
            <option value="DCCS">DCCS</option>
            <option value="DCCS|Pre-Switch">DCCS Pre-Switch</option>
            <option value="DCCS|Post-Switch">DCCS Post-Switch</option>
            <option value="DCCS|Border Phase">DCCS Border Phase</option>
            <option value="STROOP Test">STROOP Test</option>
            <option value="STROOP Test|Congruent">STROOP Test Congruent</option>
            <option value="STROOP Test|Incongruent">STROOP Test Incongruent</option>
            <option value="CANTAB">CANTAB Test</option>
        </select>
    </div>
</div>
<div class="row">
    <div class="col-md-4 mb-3">
        <div class="card shadow-sm">
            <div class="card-body">
                <div class="row">
                    <div class="col-8">
                        <div class="row">
                            <div class="col-12">
                                <div class="card-title text-muted text-nowrap">Registered participant</div>
                            </div>
                            <div class="col-12">
                                <h3>{{(data.count?.participant | numberFormat) || 0}}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 d-flex justify-content-center align-items-center">
                        <i class="material-icons text-primary display-4 lh-1">group</i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4 mb-3">
        <div class="card shadow-sm">
            <div class="card-body">
                <div class="row">
                    <div class="col-8">
                        <div class="row">
                            <div class="col-12">
                                <div class="card-title text-muted text-nowrap">Average Point</div>
                            </div>
                            <div class="col-12">
                                <h3>{{(data.count?.point | numberFormat) || 0}}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 d-flex justify-content-center align-items-center">
                        <i class="material-icons text-primary display-4 lh-1">verified_user</i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4 mb-3">
        <div class="card shadow-sm">
            <div class="card-body">
                <div class="row">
                    <div class="col-8">
                        <div class="row">
                            <div class="col-12">
                                <div class="card-title text-muted text-nowrap">Best Time</div>
                            </div>
                            <div class="col-12">
                                <h3>{{(data.count?.time || '00:00:00') | timeFormat:'HH:mm:ss'}}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 d-flex justify-content-center align-items-center">
                        <i class="material-icons text-primary display-4 lh-1">pending_actions</i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12 mb-3">
        <div class="card shadow-sm">
            <div class="card-body">
                <h5 class="card-title">Point</h5>
                <canvas #pointChart height="420" style="max-height:420px !important;" class="chart"></canvas>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12 mb-3">
        <div class="card shadow-sm">
            <div class="card-body">
                <h5 class="card-title">Time</h5>
                <canvas #timeChart height="420" style="max-height:420px !important;" class="chart"></canvas>
            </div>
        </div>
    </div>
</div>
<ng-template #calendarModal let-modal>
    <div class="d-flex justify-content-center">
        <ngx-daterangepicker-material [showCancel]="true" [locale]="{cancelLabel:'Reset'}" [ranges]="ranges" [startDate]="date_range.start" [endDate]="date_range.end" [alwaysShowCalendars]="true" (choosedDate)="calendarDialog.submit($event)" (cancelClicked)="calendarDialog.cancel()"></ngx-daterangepicker-material>
    </div>
</ng-template>
<div class="d-none modal-transparent lg modal-lg">&nbsp;</div>
